import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "copy",
  "use": "copy-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"copy\"><path d=\"M10.146 14h1.412v-1.5h-1.412zm-2.352 0h1.412v-1.5H7.794zM11 0H0v11h3v.559h1.5V11H11V4.5h.559V3H11zM9.5 9.5h-8v-8h8zM3 14h1.5v-1.5H3zm2.441 0h1.411v-1.5H5.441zm7.059 0H14v-1.5h-1.5zm0-11v1.5H14V3zm0 3.853H14V5.441h-1.5zm0 2.353H14V7.794h-1.5zm0 2.353H14v-1.412h-1.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol